var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChecked(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/checkbox/checked"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Exclude"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_13360_136505",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 4.5C6.38781 4.5 4 6.88782 4 9.83333V23.1667C4 26.1122 6.38782 28.5 9.33333 28.5H22.6667C25.6122 28.5 28 26.1122 28 23.1667L28 11.1667H22.6667L22.6667 4.5H9.33333Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 4.5C6.38781 4.5 4 6.88782 4 9.83333V23.1667C4 26.1122 6.38782 28.5 9.33333 28.5H22.6667C25.6122 28.5 28 26.1122 28 23.1667L28 11.1667H22.6667L22.6667 4.5H9.33333Z",
    fill: "#DFECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 23.1667H26.6667H28ZM28 11.1667H29.3333V9.83333H28V11.1667ZM22.6667 11.1667L21.3333 11.1667L21.3333 12.5H22.6667V11.1667ZM22.6667 4.5L24 4.5L24 3.16667H22.6667V4.5ZM5.33333 9.83333C5.33333 7.6242 7.12419 5.83333 9.33333 5.83333V3.16667C5.65143 3.16667 2.66667 6.15144 2.66667 9.83333H5.33333ZM5.33333 23.1667V9.83333H2.66667V23.1667H5.33333ZM9.33333 27.1667C7.1242 27.1667 5.33333 25.3758 5.33333 23.1667H2.66667C2.66667 26.8486 5.65144 29.8333 9.33333 29.8333V27.1667ZM22.6667 27.1667H9.33333V29.8333H22.6667V27.1667ZM26.6667 23.1667C26.6667 25.3758 24.8758 27.1667 22.6667 27.1667V29.8333C26.3486 29.8333 29.3333 26.8486 29.3333 23.1667H26.6667ZM26.6667 11.1667L26.6667 23.1667H29.3333L29.3333 11.1667H26.6667ZM28 9.83333H22.6667V12.5H28V9.83333ZM24 11.1667L24 4.5L21.3333 4.5L21.3333 11.1667L24 11.1667ZM9.33333 5.83333H22.6667V3.16667H9.33333V5.83333Z",
    fill: "#5A8DF1",
    mask: "url(#path-1-inside-1_13360_136505)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 39889",
    d: "M21.334 4.5H22.6673C25.6128 4.5 28.0007 6.88781 28.0007 9.83333V12.5H21.334V4.5Z",
    fill: "#DFECFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 920",
    d: "M10.666 13.1667L15.901 18.2272C16.4356 18.7439 17.2896 18.7236 17.799 18.1819L30.666 4.5",
    stroke: "#5A8DF1",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChecked);
export default __webpack_public_path__ + "static/media/ic_checked.e0789bf5ed153d289859a3b5508437d2.svg";
export { ForwardRef as ReactComponent };